import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { Carriers } from "../fulfillments/fulfillment-carriers-and-services";

export const ThirdPartyBillingAccountSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  carrier: createEnum(Carriers, { enumName: "Carriers" }),
  accountNumber: z.string(),
  accountName: z.string(),
  country: z.string(),
  postalCode: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ThirdPartyBillingAccount = z.infer<
  typeof ThirdPartyBillingAccountSchema
>;

export const CreateThirdPartyBillingAccountSchema =
  ThirdPartyBillingAccountSchema.omit({
    _id: true,
    createdAt: true,
    updatedAt: true,
  });

export type CreateThirdPartyBillingAccount = z.infer<
  typeof CreateThirdPartyBillingAccountSchema
>;
